export default "__VITE_ASSET__DrXu0t8W__"